import { v4 as uuidv4 } from 'uuid'

export interface IdGenerator {
  generate(): string
}

export class UuidIdGenerator implements IdGenerator {
  generate(): string {
    return uuidv4().replace(/-/g, '')
  }
}

export class SequentialIdGenerator implements IdGenerator {
  private currentId: number
  constructor(startFrom?: number) {
    this.currentId = startFrom ?? 1
  }
  generate(): string {
    const id = this.currentId++
    return id.toString()
  }
}
